import script from "./NewPasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./NewPasswordForm.vue?vue&type=style&index=0&id=3ccae738&lang=scss"

const __exports__ = script;

export default __exports__